import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  topHeading: {
    textAlign: "center",
    marginBottom: "25px",
  },
  mainHeading: {
    color: "#8C2148",
  },
  profileBlock: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr", // two rows of equal height
    gap: theme.spacing(2), // optional spacing between rows
    height: "100%",
  },
  eachProfile: {},
  inputContainer: {
    width: "100%",
    marginBottom: theme.spacing(10),
    height: "15px",
    margin: "12px 5px",
    "& .MuiInputBase-root": {
      padding: "0px",
    },
    "& .MuiFormControl-root > .MuiOutlinedInput-root > textarea": {
      position: "relative",
      top: "15px",
      left: "5px",
      height: "55px !important",
    },
  },
  instructionBox: {
    display: "flex",
    marginTop: "20px",
    whiteSpace: "break-spaces",
  },
  emphText: {
    fontWeight: 600,
  },
  buttonSubmitContainer: {
    margin: "auto",
    width: "100%",
    display: "flex",
    justifyContent: "left",
    padding: theme.spacing(8, 0),
  },

  buttonPrimary: {
    background: theme.palette.Primary.background,
    textTransform: "capitalize",
    height: 35,
    borderColor: theme.palette.Primary.background,
    marginRight: 15,
    fontWeight: 400,
    color: theme.palette.background.white,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      borderColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
}));

export default useStyles;
